import React from "react";
import {
  Box,
  ButtonGroup,
  IconButton,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import styles from "./Privilege.module.css";
import { PaginationDetails } from "../../Utils/Utils";
import { useState } from "react";
import { useEffect } from "react";
import {
  openDeletePrivilegeModal,
  openEditPrivilegeModal,
} from "../../Store/Slices/privilegeSlice";

const PrivilegeTable = ({ data }) => {
  const dispatch = useDispatch();
  const [roles, setRoles] = useState("");

  useEffect(() => {
    const getRoles = () => {
      if (typeof window !== undefined) {
        setRoles(sessionStorage.getItem("role"));
      }
    };
    getRoles();
  }, []);

  const { page, count, handleChange, _DATA } = PaginationDetails(data);

  return (
    <>
      <TableContainer className={styles.container}>
        <Table stickyHeader aria-label="simple table" className={styles.table}>
          <TableHead>
            <TableRow>
              <TableCell width={100}>Id</TableCell>
              <TableCell width={200}>Name</TableCell>
              <TableCell align="center" width={"30%"}>
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {_DATA.currentData()?.map((priv) => (
              <TableRow className={styles.row} key={priv.privilegeId}>
                <TableCell className={styles.tCell} component="th" scope="row">
                  #{priv.privilegeId}
                </TableCell>
                <TableCell className={styles.tCell}>
                  {priv.privilegeName}
                </TableCell>
                <TableCell className={styles.tCell} align="center">
                  <ButtonGroup variant="text" aria-label="text button group">
                    {roles?.split(",").includes("PRIV_ECOM_EDITPRIVILEGE") && (
                      <IconButton
                        onClick={() => {
                          dispatch(openEditPrivilegeModal(priv.privilegeId));
                        }}
                      >
                        <Edit />
                      </IconButton>
                    )}
                    {roles
                      ?.split(",")
                      .includes("PRIV_ECOM_DELETEPRIVILEGE") && (
                      <IconButton
                        onClick={() => {
                          dispatch(openDeletePrivilegeModal(priv.privilegeId));
                        }}
                      >
                        <Delete />
                      </IconButton>
                    )}
                  </ButtonGroup>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box my={2} display="flex" justifyContent="center">
        <Pagination
          count={count}
          size="large"
          page={page}
          variant="outlined"
          color="primary"
          onChange={handleChange}
          className={styles.pagination}
        />
      </Box>
    </>
  );
};

export default PrivilegeTable;
